import React from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";
import InputText from "../InputText";

const FormInputText = ({
  name,
  onChange = null,
  onBlur = null,
  label,
  hint = "",
  required = false,
  className = "mb-3",
  ...rest
}) => {
  const [field, meta] = useField(name);

  const getError = () => {
    if (!meta.touched || !meta.error) return null;
    if (Array.isArray(meta.error)) return meta.error.join(", ");
    return meta.error;
  };

  const error = getError();

  return (
    <Form.Group className={className}>
      <Form.Label>
        {label} {required && "*"}
      </Form.Label>
      <InputText
        name={name}
        value={field.value}
        onChange={onChange ?? field.onChange}
        onBlur={onBlur ?? field.onBlur}
        {...rest}
      />
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      {error && (
        <div>
          <small className="text-danger">{error}</small>
        </div>
      )}
    </Form.Group>
  );
};

export default FormInputText;
